import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGeneralOptions } from 'API/generalOptions/generalOptions';
export interface GeneralOptionsState {
  generalOptions: IGeneralOptions | null;
}

const initialState: GeneralOptionsState = {
  generalOptions: null,
};

export const generalOptionsSlice = createSlice({
  name: 'generalOptions',
  initialState,
  reducers: {
    setGeneralOptions: (
      state: GeneralOptionsState,
      action: PayloadAction<IGeneralOptions | null>
    ) => {
      state.generalOptions = action.payload;
    },
  },
});

export const { setGeneralOptions } = generalOptionsSlice.actions;

export default generalOptionsSlice.reducer;
